import React from 'react';
import CommonHeader from '../Components/Headers/CommonHeader';
import ProfileAreaContent from '../Components/ProfileArea/ProfileAreaContent';
import { userAppContext } from '../Context/Context';
import NotLoginPage from '../Components/ProfileArea/NotLoginPage';

const ProfileArea = () => {
  const { authorization, isAuthenticated } = userAppContext();

  return (
    <React.Fragment>
      <CommonHeader />
      {!isAuthenticated ? <NotLoginPage /> : <ProfileAreaContent />}
    </React.Fragment>
  );
};

export default ProfileArea;
